import React, { useState } from 'react';
import SafeIcon from '../common/SafeIcon';

const INITIAL_STAFF = [
  { id: 1, firstName: 'Kwesi', lastName: 'Mensah', email: 'kmensah@rmghana.com', role: 'Administrator', avatar: 'https://i.pravatar.cc/150?img=11' },
  { id: 2, firstName: 'Ama', lastName: 'Appiah', email: 'aappiah@rmghana.com', role: 'HR Manager', avatar: 'https://i.pravatar.cc/150?img=32' },
  { id: 3, firstName: 'Samuel', lastName: 'Boateng', email: 'sboateng@rmghana.com', role: 'Viewer', avatar: 'https://i.pravatar.cc/150?img=12' },
];

const Staff = () => {
  const [staffList, setStaffList] = useState(INITIAL_STAFF);
  const [formData, setFormData] = useState({ firstName: '', lastName: '', email: '', role: 'Viewer' });

  const handleSave = (e) => {
    e.preventDefault();
    setStaffList([...staffList, { ...formData, id: Date.now(), avatar: `https://i.pravatar.cc/150?img=${Math.floor(Math.random() * 70)}` }]);
    setFormData({ firstName: '', lastName: '', email: '', role: 'Viewer' });
  };

  return (
    <div className="max-w-5xl mx-auto space-y-12 pb-10">
      
      {/* Form Section */}
      <section className="space-y-8 pt-4">
        <h2 className="text-xl font-bold text-gray-800">
          Add New Staff Member
        </h2>
        
        <form onSubmit={handleSave} className="w-full">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6 mb-8">
            <div className="space-y-2">
              <label className="text-[11px] font-bold text-gray-400 uppercase tracking-widest">First Name</label>
              <input 
                type="text" 
                required 
                value={formData.firstName} 
                onChange={(e) => setFormData({...formData, firstName: e.target.value})} 
                className="w-full px-4 py-2.5 rounded border border-gray-200 focus:border-[#11469A] bg-white outline-none transition-all text-sm text-gray-700" 
              />
            </div>
            <div className="space-y-2">
              <label className="text-[11px] font-bold text-gray-400 uppercase tracking-widest">Last Name</label>
              <input 
                type="text" 
                required 
                value={formData.lastName} 
                onChange={(e) => setFormData({...formData, lastName: e.target.value})} 
                className="w-full px-4 py-2.5 rounded border border-gray-200 focus:border-[#11469A] bg-white outline-none transition-all text-sm text-gray-700" 
              />
            </div>
            <div className="space-y-2">
              <label className="text-[11px] font-bold text-gray-400 uppercase tracking-widest">Email Address</label>
              <input 
                type="email" 
                required 
                value={formData.email} 
                onChange={(e) => setFormData({...formData, email: e.target.value})} 
                className="w-full px-4 py-2.5 rounded border border-gray-200 focus:border-[#11469A] bg-white outline-none transition-all text-sm text-gray-700" 
              />
            </div>
            <div className="space-y-2">
              <label className="text-[11px] font-bold text-gray-400 uppercase tracking-widest">Role Assignment</label>
              <select 
                className="w-full px-4 py-2.5 rounded border border-gray-200 focus:border-[#11469A] bg-white outline-none transition-all text-sm text-gray-700 appearance-none bg-[url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%236b7280%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E')] bg-[length:12px_12px] bg-[right_16px_center] bg-no-repeat pr-10" 
                value={formData.role} 
                onChange={(e) => setFormData({...formData, role: e.target.value})}
              >
                <option>Administrator</option>
                <option>HR Manager</option>
                <option>Viewer</option>
              </select>
            </div>
          </div>
          <button type="submit" className="bg-[#21438B] hover:bg-[#1a3670] text-white px-8 py-3 rounded-md font-bold transition-all uppercase tracking-wider text-[11px]">
            Register Staff
          </button>
        </form>
      </section>

      <div className="h-px bg-gray-100 w-full" />

      {/* Directory Section */}
      <section className="space-y-6">
        <div className="flex justify-between items-center pb-2">
          <h3 className="font-bold text-gray-800">Internal Staff Directory</h3>
          <span className="text-[11px] font-bold text-gray-400 uppercase tracking-widest">{staffList.length} Members</span>
        </div>
        
        <div className="space-y-8">
          {staffList.map((member) => (
            <div key={member.id} className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 group">
              <div className="flex items-center gap-5">
                <img src={member.avatar} className="w-14 h-14 rounded-[14px] object-cover shadow-sm grayscale-[20%]" alt="" />
                <div>
                  <h3 className="text-[15px] font-bold text-gray-800">{member.firstName} {member.lastName}</h3>
                  <p className="text-gray-400 text-[13px] mt-0.5">{member.email}</p>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-[#f4f7fa] text-[#21438B] text-[10px] font-bold uppercase tracking-widest">
                  <SafeIcon name="Shield" size={12} className="opacity-80" /> {member.role.toUpperCase()}
                </span>
                <button 
                  onClick={() => setStaffList(staffList.filter(s => s.id !== member.id))} 
                  className="p-2 text-gray-300 hover:text-red-500 opacity-0 group-hover:opacity-100 transition-opacity"
                >
                  <SafeIcon name="Trash2" size={16} />
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>

    </div>
  );
};

export default Staff;